export enum ESubModules {
PAYEE_MATCH_PARAM = 'PAYEE_MATCH_PARAM', //Payee Match Parameter
USER_ROLE = 'USER_ROLE', //User Roles
DAILY_CHK_ISSUE_SUM = 'DAILY_CHK_ISSUE_SUM', //Daily Checks Issued Summary
DATA_IMPORT_PROCESS = 'DATA_IMPORT_PROCESS', //Data Import Processing
SUBMIT_ISSUE_CHEK_FIL = 'SUBMIT_ISSUE_CHEK_FIL', //Submit Issued Check File
ISSUE_CHK_PROCESS_LOG = 'ISSUE_CHK_PROCESS_LOG', //Issued Check Processing Log
FIL_MAP_FORMAT = 'FIL_MAP_FORMAT', //File Mapping Formats
SENT_EMAIL_TXT_LOG = 'SENT_EMAIL_TXT_LOG', //Sent Email/Texts
AUDIT_TRAIL_LOG = 'AUDIT_TRAIL_LOG', //Audit Trail Log
ALL_TRANS = 'ALL_TRANS', //All Transactions
  CLIENT_SETUP = 'CLIENT_SETUP', //Client Setup
  ADD_NEW_ISSUE_CHK = 'ADD_NEW_ISSUE_CHK', //Add New Issued Check
  EXCEPT_ITM = 'EXCEPT_ITM', //Exception Items
  ACH_EXCEPT_RUL = 'ACH_EXCEPT_RUL', //ACH Exception Rules
  EXCEPT_PROCESS = 'EXCEPT_PROCESS', //Quick Exception Processing
  ACC_SET = 'ACC_SET', //Account Setup
  CLIENT_USR_SET = 'CLIENT_USR_SET', //Client User Setup
  CHK_VERIFY = 'CHK_VERIFY', //Check Verification
  PURGE_TRANS = 'PURGE_TRANS', //Purge Transactions
  FIL_MAP_SET = 'FIL_MAP_SET', //File Mapping Setup
  BAT_PROCESS = 'BAT_PROCESS', //Batch Processing
  BNK_USR_SET = 'BNK_USR_SET', //Bank User Setup
  BROAD_EMAIL = 'BROAD_EMAIL', //Broadcast Email
  HELP_PAGE_MANAGE = 'HELP_PAGE_MANAGE', // Help Page Management
  ACH_EXCEPTION_RULE = 'ACH_EXCEPTION_RULE', // ACH Exception Rule
  SPECIAL_PERMISSION = 'SPECIAL_PERMISSION', // Special Permission
  SYS_WIDE_RULES = 'SYS_WIDE_RULES', // System-Wide Rules
}

export enum EPermissions {
  EDIT_EXCEPT = 'EDIT_EXCEPT', //Allow user to edit exceptions after cutoff time
  ADD_EDIT_ITEMS = 'ADD_EDIT_ITEMS', //Allow user to add/edit items in permitted Navigation Submodules
  VIEW_ITEMS = 'VIEW_ITEMS', //Allow user to view items in permitted Navigation Submodule
  DELETE_ITEMS = 'DELETE_ITEMS', //Allow user to delete items in permitted Navigation Submodules
  DOWNLOAD = 'DOWNLOAD', //Allow user to download issued check files
  AVOID_ISSUED = 'AVOID_ISSUED', //Allow user to void an issued check
  UPLOAD = 'UPLOAD', //Allow user to upload issued check files
  ADD_ACH_EXCEPT_RUL = 'ADD_ACH_EXCEPT_RUL', //Allow user to add ACH Exception Rules
  DECISION_EXCEPT = 'DECISION_EXCEPT', //Allow user to Decision Exceptions
  PURGE_FILE = 'PURGE_FILE', //Allow user to purge files
  FULL = 'FULL', //Allow user to have full access to the Navigation Submodule
  DECISION_CHECK_EXCEPT_BF = 'DECISION_CHECK_EXCEPT_BF', // Decision Check Exception Before
  DECISION_ACH_EXCEPT_RUL_BF = 'DECISION_ACH_EXCEPT_RUL_BF', // Decision ACH Exception Rule Before
  VIEW_ACH_EXCEPT_RUL = 'VIEW_ACH_EXCEPT_RUL', // View ACH Exception Rule
  VIEW_CHECK_EXCEPT = 'VIEW_CHECK_EXCEPT', // View Check Exception
  EDIT_CHECK_EXCEPT_AF = 'EDIT_CHECK_EXCEPT_AF', // Edit Check Exception After cutoff time
  EDIT_ACH_EXCEPT_RUL_AF = 'EDIT_ACH_EXCEPT_RUL_AF', // // Edit ACH Exception After cutoff time
  SEND_MANUALLY_EXCEPT_NOTIF = 'SEND_MANUALLY_EXCEPT_NOTIF', // Manually send exception notification emails (bank users only)
}

export const EXCLUDED_HELP_PAGE_SUBMODULES = [
  'ALL_TRANS_RESULTS',
  'ISSUE_CHK_PROCESS_LOG_RESULTS',
  'VIEW_ERROR_DETAILS',
  'VIEW_AUDIT_HISTORY',
  'ADD_ACH_EXCEPT_RUL',
  'VIEW_ACH_EXCEPT_RUL',
  'VIEW_TRANSACTION',
  'EDIT_ACH_EXCEPT_RUL',
]

export const EXCLUDED_NAVIGATION_SUBMODULES = [
  'All Transactions Results',
  'Check File Upload History Results',
  'View Error Details',
  'View Audit History',
  'Add ACH Exception Rule',
  'View ACH Exception Rule',
  'View Transaction',
  'Edit ACH Exception Rule',
]

// Navigation submodules assignable/visible only for the Super Admin role (matched by UserRoleIds.SUPER_ADMIN)
export const SUPER_ADMIN_ONLY_NAVIGATION_SUBMODULES = ['System-Wide Rules']

// Permissions assignable/visible only for the Super Admin role in the User Roles editor (matched by display name)
export const SUPER_ADMIN_ONLY_PERMISSIONS = ['Allow user to view System-Wide Rules']

export type IUserPermissions = Partial<Record<ESubModules, Array<EPermissions>>>
